import { PublicPageHeader } from "../../../components/headers/header-public-page/header-public-page";
import { Navbar } from "../../../components/nav";
import { useStyles } from "./confirmar-entrega-page-style";
import { ConfirmarEntregaData } from "./components/confirmar-entrega-data/confirmar-entrega-data";
import { useCallback } from "react";
import { useHistory } from "react-router";
import { KdsStorageKeys, useKdsStorage } from "../../../../services/app";
import { ModuloModel } from "../../../../model/app/forms/master/modulo-model";
import { EnumModulo } from "../../../../model/enums/enum-modulo";
import { ConfirmarEntregaDataMotoboy } from "./components/confirmar-entrega-data-motoboy/confirmar-entrega-data-motoboy";

const ConfirmarEntregaPage = () => {
    const classes = useStyles();
    const history = useHistory();
    const { getRegistro } = useKdsStorage();

    const tipoTrabalho = getRegistro(KdsStorageKeys.SelecaoModulo, false) as ModuloModel;

    const voltarPagina = useCallback(() => {
        history.replace('/')
    }, [history])

    return (
        <>
            <PublicPageHeader topOpacity="0.8" />
            <div className={classes.divRoot}>
                <Navbar
                    buttonBack={true}
                    voltar={voltarPagina}
                    titulo="Confirmar Entrega"
                />
                <div className={classes.root}>
                    {tipoTrabalho.modulo === EnumModulo.Motoboy ? (
                        <ConfirmarEntregaDataMotoboy />
                    ) : (
                        <ConfirmarEntregaData />
                    )}
                </div>
            </div>
        </>
    )
}

export default ConfirmarEntregaPage;